module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "toolbar"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.addRole(0)
      }
    }
  }, [_vm._v("新增角色")])], 1), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingTable),
      expression: "loadingTable"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.getRoleList,
      "element-loading-text": "拼命加载中",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "RoleName",
      "label": "角色"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "property": "Id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "edit"
          },
          on: {
            "click": function($event) {
              _vm.handleEditPerson(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑人员")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "icon": "setting"
          },
          on: {
            "click": function($event) {
              _vm.handleEditPower(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改权限")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "icon": "delete"
          },
          on: {
            "click": function($event) {
              _vm.del(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.addRoleForm.title
    },
    model: {
      value: (_vm.roleDialog),
      callback: function($$v) {
        _vm.roleDialog = $$v
      },
      expression: "roleDialog"
    }
  }, [_c('el-form', {
    ref: "addRoleForm",
    attrs: {
      "data": _vm.addRoleForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色名称"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addRoleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addRoleForm, "name", $$v)
      },
      expression: "addRoleForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权限设置"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.checkAll
    },
    model: {
      value: (_vm.addRoleForm.checked),
      callback: function($$v) {
        _vm.$set(_vm.addRoleForm, "checked", $$v)
      },
      expression: "addRoleForm.checked"
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.addRoleForm.type,
      "show-checkbox": "",
      "default-expand-all": "",
      "expand-on-click-node": false,
      "node-key": "MenuId",
      "highlight-current": "",
      "props": _vm.defaultProps
    },
    on: {
      "check-change": _vm.handleCheckChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.roleDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.btnLoading
    },
    on: {
      "click": function($event) {
        _vm.getChecked(0)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('el-dialog', {
    attrs: {
      "title": "编辑人员"
    },
    model: {
      value: (_vm.roleControlDialog),
      callback: function($$v) {
        _vm.roleControlDialog = $$v
      },
      expression: "roleControlDialog"
    }
  }, [_c('el-form', {
    ref: "addRoleForm",
    attrs: {
      "data": _vm.roleControlForm,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.roleControlForm.roleName),
      callback: function($$v) {
        _vm.$set(_vm.roleControlForm, "roleName", $$v)
      },
      expression: "roleControlForm.roleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "包含人员"
    }
  }, [(_vm.roleControlForm.dynamicTags.length == 0) ? _c('div', [_vm._v("暂无人员")]) : _c('div', [_vm._l((_vm.roleControlForm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": true,
        "close-transition": false
      },
      on: {
        "close": function($event) {
          _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n              " + _vm._s(tag.EmployeeName) + "\n            ")])
  }), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('el-autocomplete', {
    attrs: {
      "icon": "search",
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "新增人员"
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.roleControlForm.state),
      callback: function($$v) {
        _vm.$set(_vm.roleControlForm, "state", $$v)
      },
      expression: "roleControlForm.state"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.roleControlDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.submitRoleControlForm
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ccc672ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/acountManage/roleControl.vue
// module id = 1565
// module chunks = 1